export default "__VITE_ASSET__9hoA8KoG__"